(function () {
  "use strict";

  var HISTORY_KEY = "__terrysM2MBuyingOptionsHistoryV1";
  var initialized = false;
  var configs = [];
  var currentConfig = null;
  var recalculationRequested = false;
  var suppressObserver = false;
  var checkScheduled = false;

  function isVisible(element) {
    if (!element || element.classList.contains("hidden")) {
      return false;
    }

    return Boolean(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  }

  function getHistoryState() {
    return history.state &&
      typeof history.state === "object" &&
      !Array.isArray(history.state)
      ? history.state
      : {};
  }

  function isOptionsState(state) {
    return Boolean(state && state[HISTORY_KEY]);
  }

  function getFabricTabPaneId(root) {
    var tabPane = root.closest("#curtains-product, #blinds-product");

    return tabPane ? tabPane.id : null;
  }

  function getConfig(root) {
    var tabPaneId = getFabricTabPaneId(root);

    if (root.classList.contains("buying-options-curtains")) {
      return {
        kind: "curtains",
        root: root,
        tabPaneId: tabPaneId,
        measurementScreen: root.querySelector(".tf-product-widths"),
        optionsScreen: root.querySelector(".product-price-options"),
        measurementInputs: "#width, #drop, #curtain_width, #curtain_drop"
      };
    }

    return {
      kind: "blinds",
      root: root,
      tabPaneId: tabPaneId,
      measurementScreen: root.querySelector(".step1, #step1"),
      optionsScreen: root.querySelector(".step2, #step2"),
      measurementInputs: "#cWidth, #cDrop, #blind_width, #blind_drop"
    };
  }

  function isOptionsScreenOpen(config) {
    return (
      isVisible(config.optionsScreen) &&
      !isVisible(config.measurementScreen)
    );
  }

  function activateBespokeTab(config) {
    if (!config.tabPaneId) {
      return;
    }

    var tabLink = document.querySelector(
      '.bespoke-tabs a[href="#' + config.tabPaneId + '"]'
    );

    if (!tabLink) {
      return;
    }

    if (
      window.jQuery &&
      window.jQuery.fn &&
      typeof window.jQuery.fn.tab === "function"
    ) {
      window.jQuery(tabLink).tab("show");
    } else {
      tabLink.click();
    }
  }

  function scrollToConfigurator(config) {
    var stickyHeader = document.querySelector("#StickyHeader");
    var headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    var top =
      config.root.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth"
    });
  }

  function clearMeasurements(config) {
    var inputs = config.root.querySelectorAll(config.measurementInputs);

    Array.prototype.forEach.call(inputs, function (input) {
      input.value = "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function showMeasurementScreen(config, clearInputs) {
    suppressObserver = true;
    activateBespokeTab(config);

    if (config.kind === "curtains") {
      config.optionsScreen.style.display = "none";
      config.measurementScreen.style.display = "";
    } else {
      config.optionsScreen.classList.add("hidden");
      config.measurementScreen.classList.remove("hidden");
    }

    if (clearInputs) {
      clearMeasurements(config);
    }

    config.wasOpen = false;
    currentConfig = config;

    window.requestAnimationFrame(function () {
      scrollToConfigurator(config);

      window.requestAnimationFrame(function () {
        suppressObserver = false;
      });
    });
  }

  function showOptionsScreen(config) {
    suppressObserver = true;
    activateBespokeTab(config);

    if (config.kind === "curtains") {
      config.optionsScreen.style.display = "block";
      config.measurementScreen.style.display = "none";
    } else {
      config.optionsScreen.classList.remove("hidden");
      config.measurementScreen.classList.add("hidden");
    }

    config.wasOpen = true;
    currentConfig = config;

    window.requestAnimationFrame(function () {
      scrollToConfigurator(config);

      window.requestAnimationFrame(function () {
        suppressObserver = false;
      });
    });
  }

  function pushOptionsHistory(config) {
    if (isOptionsState(history.state)) {
      var currentState = history.state[HISTORY_KEY];

      // Fabric PDPs contain both configurators. If the customer changes from
      // one stage-2 tab to the other, keep a single history entry but update
      // it so Back and Forward restore the configurator currently in use.
      if (
        currentState.kind !== config.kind ||
        currentState.tabPaneId !== config.tabPaneId
      ) {
        var replacementState = Object.assign({}, getHistoryState());

        replacementState[HISTORY_KEY] = {
          step: "options",
          kind: config.kind,
          tabPaneId: config.tabPaneId
        };

        history.replaceState(
          replacementState,
          document.title,
          window.location.href
        );
      }

      currentConfig = config;
      return;
    }

    var nextState = Object.assign({}, getHistoryState());

    nextState[HISTORY_KEY] = {
      step: "options",
      kind: config.kind,
      tabPaneId: config.tabPaneId
    };

    history.pushState(nextState, document.title, window.location.href);
    currentConfig = config;
  }

  function checkForSuccessfulCalculation() {
    checkScheduled = false;

    if (suppressObserver) {
      return;
    }

    configs.forEach(function (config) {
      var optionsOpen = isOptionsScreenOpen(config);

      // Only a successful closed-to-open transition creates a history entry.
      if (optionsOpen && !config.wasOpen) {
        pushOptionsHistory(config);
      }

      config.wasOpen = optionsOpen;
    });
  }

  function scheduleCheck() {
    if (checkScheduled) {
      return;
    }

    checkScheduled = true;
    window.requestAnimationFrame(checkForSuccessfulCalculation);
  }

  function findConfig(kind, tabPaneId) {
    var matchingConfig = null;

    if (tabPaneId) {
      matchingConfig = configs.filter(function (config) {
        return config.kind === kind && config.tabPaneId === tabPaneId;
      })[0];

      if (matchingConfig) {
        return matchingConfig;
      }
    }

    return (
      configs.filter(function (config) {
        return config.kind === kind;
      })[0] || null
    );
  }

  function handlePopState(event) {
    var stateData = isOptionsState(event.state)
      ? event.state[HISTORY_KEY]
      : null;

    // Browser Forward restores stage 2 while its calculated data is available.
    if (stateData && stateData.step === "options") {
      var forwardConfig = findConfig(stateData.kind, stateData.tabPaneId);

      if (forwardConfig) {
        showOptionsScreen(forwardConfig);
      }

      return;
    }

    // Browser Back restores stage 1 without leaving the product page.
    var openConfig =
      currentConfig || configs.filter(isOptionsScreenOpen)[0];

    if (openConfig) {
      showMeasurementScreen(openConfig, recalculationRequested);
    }

    recalculationRequested = false;
  }

  function handleRecalculateClick(event) {
    var button = event.target.closest(".btn-recalculate");

    if (!button || !isOptionsState(history.state)) {
      return;
    }

    var root = button.closest(
      ".buying-options-curtains, .buying-options-blinds"
    );

    if (!root) {
      return;
    }

    // Recalculate uses the same transition and removes the redundant stage-2
    // history entry. The existing behavior of clearing measurements is kept.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    currentConfig =
      configs.filter(function (config) {
        return config.root === root;
      })[0] || currentConfig;

    recalculationRequested = true;
    history.back();
  }

  function init() {
    if (initialized) {
      return;
    }

    var roots = document.querySelectorAll(
      ".buying-options-curtains, .buying-options-blinds"
    );

    if (!roots.length) {
      return;
    }

    Array.prototype.forEach.call(roots, function (root) {
      var config = getConfig(root);

      if (!config.measurementScreen || !config.optionsScreen) {
        return;
      }

      config.wasOpen = isOptionsScreenOpen(config);
      configs.push(config);

      var observer = new MutationObserver(scheduleCheck);

      observer.observe(config.root, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    });

    if (!configs.length) {
      return;
    }

    initialized = true;
    window.addEventListener("popstate", handlePopState);
    document.addEventListener("click", handleRecalculateClick, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
